import React from "react";
import ReactGA from "react-ga4";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./MainPage.module.scss";
import mainTitle from "../../img/mainPage/mainTitle.png";
import tube from "../../img/mainPage/tube.png";
import bubble from "../../img/mainPage/bubble.png";
import redBall from "../../img/mainPage/redBall.png";
import greenBall from "../../img/mainPage/greenBall.png";
import jellyMan from "../../img/mainPage/jellyMan.png";
import cloud from "../../img/mainPage/cloud.png";
import belowCloud from "../../img/mainPage/belowCloud.png";
import beachBall from "../../img/mainPage/beachBall.png";
const MainPage = ({ mainPageRef }) => {
  const location = useLocation();
  const [initialized, setInitialized] = useState(false);
  useEffect(() => {
    if (!window.location.href.includes("localhost")) {
      ReactGA.initialize(process.env.REACT_APP_GA_ID);
      setInitialized(true);
    }
  }, []);
  useEffect(() => {
    if (initialized) {
      ReactGA.set({ page: location.pathname });
      ReactGA.send("pageview");
    }
    ReactGA.gtag("config", process.env.REACT_APP_GA_ID, { debug_mode: true });
  }, [initialized, location.pathname]);
  return (
    <div className={styles.container} ref={mainPageRef}>
      <div className={styles.contents_box}>
        <div className={styles.title_box}>
          <img src={mainTitle} alt="title" className={styles.main_title} />
          <div className={styles.sub_title} data-content="Summer Splash">
            Summer Splash
          </div>
          <div className={styles.date}>
            <p>May 29 - July 7</p>
          </div>
        </div>
        <a
          className={styles.dashboard_btn}
          href="https://dashboard.mondayoff.me"
          target="_blank"
          rel="noreferrer"
        >
          Join Now
        </a>
        <a
          className={styles.terms_btn}
          href="https://events.mondayoff.me/terms"
          target="_blank"
          rel="noreferrer"
        >
          Terms and Conditions
        </a>
        <img className={styles.tube} src={tube} alt="tube" />
        <img className={styles.bubble_one} src={bubble} alt="bubble" />
        <img className={styles.bubble_two} src={bubble} alt="bubble" />
        <img className={styles.bubble_three} src={bubble} alt="bubble" />
        <img className={styles.red_ball_one} src={redBall} alt="ball" />
        <img className={styles.red_ball_two} src={redBall} alt="ball" />
        <img className={styles.green_ball} src={greenBall} alt="ball" />
        <img className={styles.jelly_man} src={jellyMan} alt="jellyMan" />
        <img className={styles.beach_ball} src={beachBall} alt="beachBall" />
        <img className={styles.cloud_one} src={cloud} alt="cloud" />
        <img className={styles.cloud_two} src={cloud} alt="cloud" />
        <img className={styles.below_cloud} src={belowCloud} alt="cloud" />
      </div>
    </div>
  );
};

export default MainPage;
